import {
    store
} from "./Store"
import AWSAppSyncClient, {
    createAppSyncLink
} from "aws-appsync";
import {
    AmplifyEventBus
} from './plugins/aws-amplify-vue';
import * as localForage from "./plugins/localforage";
Vue.prototype.$localForage = localForage
import Vue from "vue";
import {
    Auth
} from 'aws-amplify';
import VueApollo from "vue-apollo";
import {
    WebSocketLink
} from 'apollo-link-ws'
import ApolloLinkTimeout from 'apollo-link-timeout';
import {
    ApolloLink
} from 'apollo-link';
import {
    createHttpLink
} from 'apollo-link-http';
import {
    onError
} from 'apollo-link-error';
import {
    setContext
} from 'apollo-link-context';
const type = 'AWS_IAM'
const aws_exports = require('./exports').default;
const onErrorLink = onError(({
    graphQLErrors,
    networkError
}) => {
    if (graphQLErrors) {
        graphQLErrors.map(({
            message,
            locations,
            path
        }) => {
            console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
            try {
                AmplifyEventBus.$emit('appEvents', {
                    exec: 'trackActivity',
                    component: 'nav',
                    params: {
                        component: "AppSync",
                        function: "error",
                        error: {
                            message: message,
                            locations: locations,
                            path: path
                        },
                        message: message
                    }
                })
            } catch (err) {
                console.log(err);
            }
        });
    }
    if (networkError) {
        let user = store.getters.get('user')
        if (user && user.username) {
            console.log('Timeout detected...')
            store.commit('change', {
                netError: networkError
            });
            console.debug(` [Network]: ${networkError}`);
            try {
                AmplifyEventBus.$emit('appEvents', {
                    exec: 'checkSub',
                    component: 'nav',
                    params: 'appsync'
                })
            } catch (err) {
                console.log(err);
            }
        } else {
            console.log('Network Error: Timeout')
        }

    }
});
const timeoutLink = new ApolloLinkTimeout(40000)
const httpLink = createHttpLink({
    uri: aws_exports.ENDPOINT
});
Vue.prototype.$appsyncURL = aws_exports.ENDPOINT
const appSyncLink = createAppSyncLink({
    url: aws_exports.ENDPOINT,
    region: aws_exports.REGION,
    path: aws_exports.PATH,
    auth: {
        type: 'AMAZON_COGNITO_USER_POOLS',
        jwtToken: async () => (await Auth.currentSession()).getIdToken().getJwtToken(),
    },
    disableOffline: true,
    resultsFetcherLink: httpLink,
    complexObjectsCredentials: () => Auth.currentCredentials(),
    fetchPolicy: 'network-only'
});
const link = ApolloLink.from([
    onErrorLink,
    timeoutLink,
    appSyncLink
])
const defaultClient = new AWSAppSyncClient({
    fetchPolicy: 'network-only',
    disableOffline: true,
    offlineConfig: {
        storage: localForage
    }
}, {
    link
});
Vue.prototype.$apolloClient = defaultClient

const apolloProvider = new VueApollo({
    defaultClient
});
Vue.prototype.$apolloProvider = apolloProvider

Vue.use(VueApollo);

export async function reconnectAppSync() {
    console.log('[AppSync] Reinitializing connection...');
    try {
        const session = await Auth.currentSession();
        await defaultClient.hydrated();
        AmplifyEventBus.$emit('appEvents', {
            exec: 'trackActivity',
            component: 'nav',
            params: {
                component: "AppSync",
                function: "reconnectApp",
                message: "AppSync connection reestablished"
            }
        });
        console.log('[AppSync] Reconnection successful.');
    } catch (err) {
        console.error('[AppSync] Reconnection failed:', err);
    }
}

export default apolloProvider;
